//@flow
export const publicKey = {
  alg: 'RSA-OAEP-512',
  e: 'AQAB',
  ext: true,
  key_ops: ['encrypt'],
  kty: 'RSA',
  n:
    'xndeVjy-E91I836FfPpb4MA5WMWiUNlsWpZsbNfr8TX5umFnBlVm_2gpp7Bc4fZQPXJjE8LcV5X3wQTYLYQoDOlB7USG65V5RAJcFkUhtjpPj6zarpIeLo5pkNmnrXR7o809PDjmzU8TS_h5Mt-Wqq1qSYGBzB3MzK7zSr5Gxeb82maWduw4eOIMkW2GNBGK-Iv9t5gtG5dtj5Ryc8ZEIkSM0vQ-Qwh8_4vWUFSCbMgO1mcComdZt57dGmlu-ylsMKLJ0J7sH4nBfyhQwZK4zdf_5_jepzeMjR-sZcGuYJXAtwLdzOWc9lzQg08mWKXPS0IVoHQ0bGxbyPweEBe90eorEcw5qFQDhx0To99P3GkIB0nyFo0IGZVLQWf1zxSlkWUb3cPwghqnVQMImjXBGtrwyknW0Jmykyei2SXUbVbmpPVeYHQUQPF_HFVoOPvdUs9ceHLBVBy33HzmW_zpkXR9echdr8H0MgwOlmc7EG2G68tOfWzK3BawxKT8NR3LOyGS-LH8qqo1EUTLOyIdFVbHnAq1xk455DkUH1a2Cv_xQZWCPhQJvWIVV7Lq07106pnMfrgZ6UgJv9UNCU_JPrvNyz9s31SOgk8H_GYMgC-Bbq9AnzS-JJK3Sc4Rc9Styl8cPJfngfD2ZsQUxTWSggTKa66vEJiEX5IZSzORvfM',
}


export const allTestLevels = ['acsf3', 'acsf4', 'acsf3shortcourse', 'vfh', 'dlrq', 'dp']

export const TYPES = ['study', 'work'];

export const changeLogoUrlToAWS = (logoUrl) => {
    if (logoUrl) {
        return logoUrl.replace(/^https:\/\/digital\.robot\//, 'https://s3.ap-southeast-2.amazonaws.com/digital.robot/');
    }
    return logoUrl;
};


// WEBPACK FOOTER //
// ./src/constants/index.js